import React from 'react'

function Discharge(props) {
  const fillColor = props.hovered === 'discharge' || props.selected === 'Discharge Event' ? '#F37320' : '#545455'
  const strokeColor = props.hovered === 'discharge' || props.selected === 'Discharge Event' ? '#F37320' : '#707070'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="163.576" height="103.267" viewBox="0 0 163.576 103.267">
      <g id="Group_7419" data-name="Group 7419" transform="translate(18288 -10545.746)">
        <g id="Rectangle_5575" data-name="Rectangle 5575" transform="translate(-18288 10551.215)" fill="#fff" stroke={strokeColor} strokeWidth="1">
          <rect width="47.601" height="97.799" rx="8" stroke="none" />
          <rect x="0.5" y="0.5" width="46.601" height="96.799" rx="7.5" fill="none" />
        </g>
        <g id="Rectangle_5576" data-name="Rectangle 5576" transform="translate(-18284.539 10564)" fill={fillColor} stroke={fillColor} strokeWidth="1">
          <rect width="40.677" height="81.551" rx="4" stroke="none" />
          <rect x="0.5" y="0.5" width="39.677" height="80.551" rx="3.5" fill="none" />
        </g>
        <path id="Path_3644" data-name="Path 3644" d="M3614.863,5076.646h19.228" transform="translate(-21888.373 5469.6)" fill="none" stroke={strokeColor} strokeLinecap="round" strokeWidth="1" />
        <g id="Rectangle_5577" data-name="Rectangle 5577" transform="translate(-18230.012 10551.215)" fill="#fff" stroke={strokeColor} strokeWidth="1">
          <rect width="47.601" height="97.799" rx="8" stroke="none" />
          <rect x="0.5" y="0.5" width="46.601" height="96.799" rx="7.5" fill="none" />
        </g>
        <g id="Rectangle_5578" data-name="Rectangle 5578" transform="translate(-18226.551 10601.412)" fill={fillColor} stroke={fillColor} strokeWidth="1">
          <rect width="40.677" height="44.139" rx="4" stroke="none" />
          <rect x="0.5" y="0.5" width="39.677" height="43.139" rx="3.5" fill="none" />
        </g>
        <path id="Path_3645" data-name="Path 3645" d="M3614.863,5076.646h19.228" transform="translate(-21830.477 5469.6)" fill="none" stroke={strokeColor} strokeLinecap="round" strokeWidth="1" />
        <g id="Rectangle_5579" data-name="Rectangle 5579" transform="translate(-18172.025 10551.215)" fill="#fff" stroke={strokeColor} strokeWidth="1">
          <rect width="47.601" height="97.799" rx="8" stroke="none" />
          <rect x="0.5" y="0.5" width="46.601" height="96.799" rx="7.5" fill="none" />
        </g>
        <g id="Rectangle_5580" data-name="Rectangle 5580" transform="translate(-18168.564 10630)" fill={fillColor} stroke={fillColor} strokeWidth="1">
          <rect width="40.677" height="15.551" rx="4" stroke="none" />
          <rect x="0.5" y="0.5" width="39.677" height="14.551" rx="3.5" fill="none" />
        </g>
        <path id="Path_3646" data-name="Path 3646" d="M3614.863,5076.646h19.228" transform="translate(-21772.58 5469.6)" fill="none" stroke={strokeColor} strokeLinecap="round" strokeWidth="1" />
      </g>
    </svg>
  )
}

export default Discharge